import { useQuery } from '@tanstack/react-query';

import { getDelayedSignals, getSandboxDelayedSignals } from '../../../../api';
import { PageParams } from '../../../../types/pagination';
import { StrategyStatus } from '../../../../types/strategy';

export const useDelayedSignals = (
  id: string | undefined,
  strategyStatus: StrategyStatus | undefined,
  data: PageParams,
) => {
  return useQuery({
    queryKey: ['delayed', id, strategyStatus, data],
    queryFn: () => {
      const params = {
        strategyId: id,
        data,
      };

      if (strategyStatus === StrategyStatus.Standard || strategyStatus === StrategyStatus.Closed) {
        return getDelayedSignals(params);
      } else {
        return getSandboxDelayedSignals(params);
      }
    },
    enabled: !!id,
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
  });
};
